import { css } from "emotion"

export const colors = {
  white: "#fff",
  black: "#000",
  text: "rgba(0, 0, 0, 0.87)",
  textGrey: "rgba(0, 0, 0, 0.54)",
  textMuted: "rgba(0, 0, 0, 0.26)",
  grey: "#b2b2b2",

  primary: "#4f5b6c",
  primaryActive: "#708090",

  secondary: "#353b47",
  secondaryActive: "rgba(48, 96, 143, 0.8)",
  error: "#f44336",

  bgGrey: "#d9d9d9",
}

export const shadows = {
  elevation1: css`
    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2),
      0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);
  `,
}

export type Breakpoint = "xs" | "sm" | "md" | "lg" | "xl"
export const breakpointsKeys: Breakpoint[] = ["xs", "sm", "md", "lg", "xl"]
export const breakpointsValues = [200, 600, 960, 1280, 1920]

export type BreakpointMap = { [key in Breakpoint]: string }

export const between = breakpointsKeys.reduce<Partial<BreakpointMap>>(
  (acc, v, idx) => {
    let lower = `(min-width: ${breakpointsValues[idx]}px)`
    let upper =
      v === "xl" ? "" : ` and (max-width: ${breakpointsValues[idx + 1] - 1}px)`

    return {
      ...acc,
      [v]: `@media ${lower}${upper}`,
    }
  },
  {}
)

export const down = breakpointsKeys.reduce<Partial<BreakpointMap>>(
  (acc, v, idx) => {
    let upper = `(max-width: ${breakpointsValues[idx]}px)`

    return {
      ...acc,
      [v]: `@media ${upper}`,
    }
  },
  {}
)

export const up = breakpointsKeys.reduce<Partial<BreakpointMap>>(
  (acc, v, idx) => {
    let lower = `(min-width: ${breakpointsValues[idx]}px)`

    return {
      ...acc,
      [v]: `@media ${lower}`,
    }
  },
  {}
)

export type Breakpoints = {
  up: Partial<BreakpointMap>
  down: Partial<BreakpointMap>
  between: Partial<BreakpointMap>
}
export const breakpoints: Breakpoints = {
  up,
  down,
  between,
}
